export default {"src":"/_next/static/media/brand_search_icon.648bda4d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};